module.exports = "{{displayValue}} <div class=svg-icons-wrp> <div class=svg-icons-wrp__empty> <svg class=\"svg-icons svg-icons_dropdown\"><use xlink:href=#icon-dropdown /> </svg> </div> <div class=\"js-clear-button svg-icons-wrp__remove\"> <svg class=\"svg-icons svg-icons_remove\"><use xlink:href=#icon-remove /> </svg> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/multiSelect/templates/multiSelectButton.hbs
// module id = 670
// module chunks = 0